module.exports = __webpack_public_path__ + "static/annis_hag-ce1f2214d8a041d7aaeb98eeeb22bfbc.jpeg";